var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('v-card',{attrs:{"flat":"","loading":_vm.loading}},[_c('v-toolbar',{attrs:{"dense":"","flat":""}},[_c('div',{staticClass:"subtitle-2"},[_vm._v("Bank Accounts")]),_c('v-spacer'),_c('CreateBank')],1),_c('List')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }